import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslationService } from '../../../translations';

@Component({
    selector: 'account-billing-wire-panel',
    template: `
        <div class="peek-panel-div">
            <div>
                <div class="title-dashboard">
                    {{
                        TR.key(
                            'billing-manager.payment-methods.peek-panel-title'
                        )
                    }}
                </div>
                <div class="title-md">
                    {{
                        TR.key(
                            'billing-manager.payment-methods.wire-panel-header'
                        )
                    }}
                </div>
            </div>
            <br /><br />
            <div class="layoutVertical">
                <span class="section-title">
                    {{
                        TR.key(
                            'billing-manager.payment-methods.wire-definition-title'
                        )
                    }}
                </span>
                <br />
                <span>
                    {{
                        TR.key(
                            'billing-manager.payment-methods.wire-definition-subtitle'
                        )
                    }}
                </span>
                <br /><br />
                <span class="section-title">
                    {{
                        TR.key(
                            'billing-manager.payment-methods.wire-process-title'
                        )
                    }}
                </span>
                <br />
                <span>
                    {{
                        TR.key(
                            'billing-manager.payment-methods.wire-process-subtitle'
                        )
                    }}
                </span>
                <br />
                <span class="section-title">
                    {{
                        TR.key(
                            'billing-manager.payment-methods.wire-process-details-title'
                        )
                    }}
                </span>
                <br />
                <span class="subsection-title">
                    {{
                        TR.key(
                            'billing-manager.payment-methods.wire-process-details.bank-name'
                        )
                    }}
                </span>
                <span class="subsection-details">{{ bankName }}</span>
                <br />
                <span class="subsection-title">
                    {{
                        TR.key(
                            'billing-manager.payment-methods.wire-process-details.routing-number'
                        )
                    }}
                </span>
                <span class="subsection-details">{{ achRoutingNumber }}</span>
                <br />
                <span class="subsection-title">
                    {{
                        TR.key(
                            'billing-manager.payment-methods.wire-process-details.account-number'
                        )
                    }}
                </span>
                <span class="subsection-details">{{ accountNumber }}</span>
                <br />
                <span class="subsection-title">
                    {{
                        TR.key(
                            'billing-manager.payment-methods.wire-process-details.swift-code'
                        )
                    }}
                </span>
                <span class="subsection-details">{{ swiftCode }}</span>
                <br />
            </div>
            <div class="peek-panel-footer">
                <div class="layoutHorizontalSpacing ">
                    <div>
                        <span>
                            <b>
                                {{
                                    TR.key(
                                        'billing-manager.billing-payment-details-peek-panel-questions'
                                    )
                                }}
                            </b>
                        </span>
                        <span>
                            {{
                                TR.key(
                                    'billing-manager.billing-payment-details-peek-panel-contact-instruction'
                                )
                            }}
                        </span>
                        <br />
                        <a
                            class="billing-email"
                            href="mailto:{{ billingHref }}"
                        >
                            {{ billingEmail }}
                        </a>
                    </div>
                    <div class="peek-panel-footer-button-container">
                        <button
                            class="button button-md button-primary"
                            (click)="closeClick()"
                        >
                            {{ TR.key('label.common-terms.close') }}
                        </button>
                    </div>
                </div>
                <br />
            </div>
        </div>
    `,
    styleUrls: ['../account-billing-manager.less'],
    standalone: false
})
export class AccountBillingWirePanelComponent implements OnInit {
    @Output()
    closePanel = new EventEmitter<boolean>();
    achRoutingNumber = '1212312412';
    accountNumber = '1895-53329-5';
    swiftCode = 'MNBDUS33';
    bankName = 'Comerica Bank';
    billingHref: string;
    billingEmail: string;

    constructor(public TR: TranslationService) {}

    ngOnInit(): void {
        this.billingEmail = this.TR.key(
            'billing-manager.billing-payment-details-peek-panel-contact-billing-email'
        );
        const billingSubject = this.TR.key(
            'billing-manager.billing-payment-details-peek-panel-contact-billing-email-subject'
        );
        this.billingHref = `${this.billingEmail}?subject=${billingSubject}`;
    }

    closeClick() {
        this.closePanel.emit(false);
    }
}
